import React from "react";
import Div from "../Div";
import SocialWidget from "./SocialWidget";

export default function Newsletter({ title, subtitle, placeholder }) {
  return (
    <>
      {title && <h2 className="cs-widget_title">{title}</h2>}
      
      <Div className="cs-newsletter cs-style1">
      <Div className="cs-newsletter_text"><SocialWidget /></Div>

        <Div className="cs-newsletter_text">{subtitle}</Div>
      </Div>
    </>
  );
}
